import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=191541ca&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=ts&"
export * from "./Customers.vue?vue&type=script&lang=ts&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=191541ca&scoped=true&lang=css&"
import style1 from "./Customers.vue?vue&type=style&index=1&id=191541ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191541ca",
  null
  
)

export default component.exports